import styled from 'styled-components';

import colors from '../../../../../styles/colors';
import UserProfileCard from '../../../../components/UserProfileCard';
import { Description } from '../../../../../components/v2/Card';
import { DraggableID } from '../../../../components/ToDoList/utils';

const Container = styled.div`
  .${DraggableID} {
    display: none;
  }

  ${Description} {
    /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    overflow: hidden;
    overflow-wrap: anywhere;
    margin-bottom: 0;
  }
`;

const Header = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 4px 4px 16px;
`;

const EmptyState = styled.div`
  color: ${colors.shades.gamma10};
  padding: 32px;
  text-align: center;
`;

const ErrorState = styled(EmptyState)`
  color: ${colors.base.danger};
`;

const ClientGroup = styled.div`
  margin-bottom: 20px;
  padding: 12px 14px 6px;
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 10px;
  background-color: ${colors.base.gamma};

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledUserProfileCard = styled(UserProfileCard)`
  max-width: fit-content;
  margin-bottom: 4px;
  a {
    text-decoration: none;
  }
`;

export {
  Container,
  Header,
  EmptyState,
  ErrorState,
  ClientGroup,
  StyledUserProfileCard,
};
